export default __webpack_public_path__ + "static/11 - Korszerűsítés-288b4e6684b12a647d2e327a8b282073.jpg";